const fineStatusBadge = (value) => {

    if (value == null || value === "") {
        return <span className="text-muted">—</span>
    }

    const display = String(value).trim().toUpperCase()
    let wrapClass = "table-sb-inactive"
    let dotClass = "dot-icon-inactive"

    if (display === "PAID") {
        wrapClass = "table-sb-active"
        dotClass = "dot-icon-active"
    } else if (display === "PARTIAL") {
        wrapClass = "table-sb-not-marked"
        dotClass = "dot-icon-not-marked"
    } else if (display === "UNPAID") {
        wrapClass = "table-sb-unpaid"
        dotClass = "dot-icon-unpaid"
    }

    return (
        <span className={`badge rounded-pill px-2 py-1 d-inline-flex align-items-center gap-2 ${wrapClass}`}>
            <span className={`dot-icon rounded-circle ${dotClass}`} />
            {display}
        </span>
    )
}

export default fineStatusBadge;